import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import AddEventPage from "../Modals/Event/AddEvent";
import EditEventPage from "../Modals/Event/EditEvent";
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [showAddEventPopup, setShowAddEventPopup] = useState(false);
  const [showEditEventPopup, setShowEditEventPopup] = useState(false);
  const [currentEvent, setCurrentEvent] = useState("");

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleAddEventClick = () => {
    setShowAddEventPopup(true);
  };

  const handleEditEventClick = (event) => {
    setCurrentEvent(event);
    setShowEditEventPopup(true);
  };

  const handleDeleteEventClick = async (eventId) => {
    try {
      await axios.delete(`/events/delete?event_id=${eventId}`);
      Swal.fire("Deleted!", "The event has been deleted.", "success");
      fetchEvents();
    } catch (err) {
      Swal.fire("Error!", "Failed to delete the event.", "error");
    }
  };

  const [userRole, setuserRole] = useState("");
  const fetchEvents = async () => {
    try {
      const response = await axios.get("/events/get_all", {
        params: {
          user_type: sessionStorage.getItem("profession_id"),
          lom_id: sessionStorage.getItem("lom"),
        },
      });
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };

  useEffect(() => {
    fetchEvents();
    const profession_id = sessionStorage.getItem("profession_id");
    if (profession_id) {
      setuserRole(profession_id);
    }
  }, []);

  function formatDate(inputDate) {
    const date = new Date(inputDate);

    const dayName = date.toLocaleDateString("en-US", { weekday: "short" });
    const day = date.getDate().toString().padStart(2, "0");
    const monthName = date.toLocaleDateString("en-US", { month: "short" });
    const year = date.getFullYear();

    return `${dayName}, ${day} ${monthName} ${year}`;
  }

  function formatDates(dateString) {
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  }

  return (
    <div className="max-w-7xl mx-auto px-2 sm:px-3 lg:px-4 mt-5 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-2 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <div className="mb-6">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Events</h1>
            {/* <button
              onClick={handleAddEventClick}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              Add Event
            </button> */}
          </div>

          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                {/* <th className="border px-4 py-2">LOM Name</th> */}
                <th className="border px-4 py-2">Program Name</th>
                <th className="border px-4 py-2">Date</th>
                <th className="border px-4 py-2">Time</th>
                <th className="border px-4 py-2">Duration</th>
                <th className="border px-4 py-2">Location</th>
                <th className="border px-4 py-2">Last Date to Apply</th>
                <th className="border px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => (
                <tr key={event.event_id}>
                  {/* <td className="border px-4 py-2">{event.lom_name}</td> */}
                  <td className="border px-4 py-2">{event.event_name}</td>
                  <td className="border px-4 py-2">
                    {formatDate(event.event_date)}
                  </td>
                  <td className="border px-4 py-2">{event.event_time}</td>
                  <td className="border px-4 py-2">{event.duration} Hrs</td>
                  <td className="border px-4 py-2">{event.event_location}</td>
                  <td className="border px-4 py-2">
                    {formatDate(event.last_date)}
                  </td>
                  <td className="border px-4 py-2 text-center flex">
                    <FaPen
                      className="text-amber-400 mt-5 text-xl cursor-pointer"
                      onClick={() => handleEditEventClick(event)}
                    />
                    {userRole !== "4" && (
                      <MdDeleteForever
                        className="ml-2 mt-5 mb-2 text-red-500 text-2xl cursor-pointer"
                        onClick={() => handleDeleteEventClick(event.event_id)}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>



          {showEditEventPopup && currentEvent && (
            <EditEventPage
              event={currentEvent}
              onClose={() => setShowEditEventPopup(false)}
              onSubmit={fetchEvents}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EventsPage;
